/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/alt-text */
import img1 from "../assets/img/Currency_converter.png";
import img2 from "../assets/img/Weather_application.png";
import img3 from "../assets/img/Stock_prediction.png";
import img4 from "../assets/img/power_bi.png";
import img5 from "../assets/img/power_e.png";
import img6 from "../assets/img/clock.png";
import "animate.css";

export const Projects = () => {

  return (
    <section className="project" id="projects">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
              <h2>Projects</h2>
              <br />
              <div className="row">
              
                <div className="col-md-4">
                <div className="card" style={{backgroundColor:"#563d7c"}}>
                  <img src={img1} className="card-img-top" alt="..." />
                  <div className="card-body" align="center">
                    <h6>Currency Converter Application</h6>
                    <p>
                    Converts Currency of any Country to the desired currency by fetching the data from exchange rate API
                    which updates regularly according to the real-time data. Implemented using Javascript and designed using 
                    Vanilla CSS to provide a user friendly interface and a to the application.
                    </p>
                    <a href="https://github.com/yasharthparas/currency-converter" className="btn btn-primary">
                      Know More...
                    </a>
                  </div>
                </div>
                </div>
                <div className="col-md-4">
                
                <div className="card" style={{backgroundColor:"#563d7c"}}>
                  <img src={img2} className="card-img-top" alt="..." />
                  <div className="card-body" align="center">
                    <h6>Weather Application</h6>
                    <p>
                    Weather details of any location at fingertips, fetches data every hour from the weather API. Used ReactJs and 
                    Bootstrap to provide a user-friendly interface, enter any location on the search bar to
                    get weather details like temperature, wind speed, humidity, etc.

                    </p>
                    <a href="https://github.com/yasharthparas/WeatherApp" className="btn btn-primary">
                    Know More...
                    </a>
                  </div>
                </div>
                </div>
                <div className="col-md-4">
                
                <div className="card" style={{backgroundColor:"#563d7c"}}>
                  <img src={img3} className="card-img-top" alt="..." />
                  <div className="card-body" align="center">
                    <h6>Stock Price Prediction</h6>
                    <p>
                    Collected and Preprocessed 5 years data of Stock Prices of a firm for designing the
                    Stock Prediction Model using libraries Numpy, Pandas, Tensorflow, etc. 
                    Created a Stacked LSTM model, predicted the future prices
                    and compared the prediction with actual values by plotting the output.

                    </p>
                    <a href="https://github.com/yasharthparas/Stock-Analysis" className="btn btn-primary">
                    Know More...
                    </a>
                  </div>
                  </div>
                </div>
            </div>
            <br/>
            <div className="row">
              
                <div className="col-md-4">
                <div className="card" style={{backgroundColor:"#563d7c"}}>
                  <img src={img4} className="card-img-top"  alt="..." />
                  <div className="card-body" align="center">
                    <h6>E-commerce Sales Dashboard</h6>
                    <p>
                    Created an interactive dashboard to track and analyze online sales data using PowerBI.
                    Used complex parameters to drill down in worksheet and customisation using filters and slicers. 
                    Used different types of customized visualization tools like bar chart, pie chart, donut chart, etc.
                    </p>
                    <a href="https://github.com/yasharthparas/Online-Sales-Dashboard" className="btn btn-primary">
                      Know More...
                    </a>
                  </div>
                </div>
                </div>
                <div className="col-md-4">
                
                <div className="card" style={{backgroundColor:"#563d7c"}}>
                  <img src={img5} className="card-img-top" alt="..." />
                  <div className="card-body" align="center">
                    <h6>Synchronous Buck Converter</h6>
                    <p>
                    Designed a Buck Converter and stepped down a 9V input voltage to 3.6V output voltage with 86%
                    efficiency and simultaneously designed a Synchronous Buck Converter with 95% efficiency. 
                    Design and analyzed the circuit with various circuital modifications to increase the performance.
                    </p>
                    <a href="https://drive.google.com/drive/folders/1L8BzRqjjTymM3VvD0yTN9FRhVq2SCu5l" className="btn btn-primary">
                    Know More...
                    </a>
                  </div>
                </div>
                </div>
                <div className="col-md-4">
                
                <div className="card" style={{backgroundColor:"#563d7c"}}>
                  <img src={img6} className="card-img-top" alt="..." />
                  <div className="card-body" align="center">
                    <h6>Digital Clock</h6>
                    <p>
                    Designed Real Time Clock and Calendar on Keil uVision using Embedded C and Implemented the circuit on Proteus with
                    functionalities of custom clock using uC and I2C protocol. 
                    Used AT89C51 uC to control the functionalities and DS1307 RTC module for the I2C protocol.
                    </p>
                    <a href="https://github.com/yasharthparas/Digital-Clock-and-Calender" className="btn btn-primary">
                    Know More...
                    </a>
                  </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
